import React, { useState, useRef, useEffect, useCallback } from "react";
import ListInfo from "../../../CourseInfo/Course/CourseInfoCreate.module.css";
import styles from "./ListPurchase.module.css";
import StyleInfo from "../../BookModule.module.css";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import ViewIcon from "./ViewIcon.png";
import { styled } from "@mui/material/styles";
import Chip from "@mui/material/Chip";
import Paper from "@mui/material/Paper";
import { Typography } from "@mui/material";
import { AxiosInstance } from "../../../../../../axios";
import Loader from "../../../../Loader";
import { R_PER_PAGE } from "../../../../../../labels";
import Pagination from "../../../../../ReusuableComponent/Pagination/Pagination";
import { useDispatch, useSelector } from "react-redux";
import { resetSetFilters } from "../../../../../../redux/purchaseBookFilterSlice";
import DatePickerSample from "../../../../DatePicker";
import CustomDownloadButton from "../../../../../ReusuableComponent/CustomDownloadButton/CustomDownloadButton";
import toast from "react-hot-toast";

function ListPurchase() {
  const location = useLocation();
  const {
    paymentMode,
    deliveryMode,
    enrolledStudent,
    BranchLocation,
    batchName,
    deliveryStatus,
    fillSearch,
    filter_date,
  } = location.state || {};

  const moment = require("moment-timezone");
  const filters = useSelector((state) => state.listBookFilter);

  const userJSON = sessionStorage.getItem("userDetails");
  let userid = null;
  let location_id = "";
  if (userJSON) {
    const user = JSON.parse(userJSON);
    if (user && user.user_id) {
      userid = user.user_id;
      location_id = user.staff_loc_id;
    }
  } else {
    console.log("UserId Not available");
  }

  const txtBSearch = useRef(null); //search icon
  const filterRef_enrolled_student = useRef(null);
  const filterRef_payment_mode = useRef(null);
  const filterRef_delivery_mode = useRef(null);
  const filterRef_branch_location = useRef(null);
  const filterRef_batch_name = useRef(null);
  const filterRef_delivery_status = useRef(null);
  const fDatePickerRef = useRef(null);
  const tDatePickerRef = useRef(null);
  const filterLastRef = useRef(null);
  const [csvData, setCsvData] = useState([]);
  // List data load table
  let page = R_PER_PAGE;
  // use state
  // user details
  const [rowsPerPage, setRowsPerPage] = useState(page);
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [sortOrder, setSortOrder] = useState("asc");
  const [sortColumn, setSortColumn] = useState("");
  const [enrolled_student, setEnrolled_student] = useState([]);
  const [payment_mode, setpayment_mode] = useState([]);
  const [delivery_mode, setDelivery_mode] = useState([]);
  const [delivery_status, setDelivery_status] = useState([
    { id: "0", name: "Pickup Pending", type: "delivery_status" },
  ]);
  const [branch_location_name, set_branch_location_name] = useState([]);
  const [batch_name, set_batch_name] = useState([]);
  const [branch, setBranch] = useState([]);
  const [batchList, setBatchList] = useState([]);
  const [updateListData, setUpdateListData] = useState();
  const [dupData, setDupData] = useState();
  const [updateChipData, setUpdateChipData] = useState([
    { id: "0", name: "Pickup Pending", type: "delivery_status" },
  ]);
  const [isOpen, setIsOpen] = useState({
    type: false,
    category: false,
    enrolled_student: false,
    payment_mode: false,
    delivery_mode: false,
    batch_name: false,
    delivery_status: false,
    branch_location_name: false,
    startDates: false,
  });
  const [appOns, setAppOns] = useState([]);
  const [appDatas, setAppDatas] = useState({
    FDate: "",
    TDate: "",
    Days: "",
    name: "",
  });
  let filterSearch = [];

  useEffect(() => {
    if (searchTerm.length > 0) {
      filterSearch = [{ name: "" + searchTerm, type: "search" }];
    } else {
      filterSearch = [];
    }
    // dispatch(resetSetFilters())
  }, [searchTerm]);

  function updateStateData() {
    filterDeliveryMode = delivery_mode;
    filterDeliveryStatus = delivery_status;
    filterEnrollStudent = enrolled_student;
    filterApplyeds = appOns;
    filterPayment = payment_mode;
    filterBranchLocation = branch_location_name;
    filterBatch = batch_name;
    if (searchTerm.length > 0) {
      filterSearch = [{ name: "" + searchTerm, type: "search" }];
    } else {
      filterSearch = [];
    }
  }

  const handleSearch = (event) => {
    if (event.key === "Enter") {
      let val = event.target.value;
      updateStateData();
      setSearchTerm(val);
      if (val.length > 0) {
        filterSearch = [{ name: "" + val, type: "search" }];
      } else {
        filterSearch = [];
      }
      loadChipdata();
    }
  };

  useEffect(() => {
    setUpdateListData(updateListData);
  }, [updateListData]);

  const handleSort = (event, sortKey) => {
    event.preventDefault();
    let order = sortOrder === "asc" ? "desc" : "asc";
    setSortOrder(order);
    let sortedList = updateListData.sort((a, b) => {
      if (a[sortKey] < b[sortKey]) {
        return order === "asc" ? -1 : 1;
      }
      if (a[sortKey] > b[sortKey]) {
        return order === "asc" ? 1 : -1;
      }
      if (a[sortKey] == b[sortKey]) {
        return order === "asc" ? 1 : -1;
      }
      return 0;
    });
    setUpdateListData(sortedList);
    setSortColumn(sortKey);
  };

  const handleCheckboxChange = (event, names, typename) => {
    const { value, checked, name } = event.target;

    if (typename === "enrolled_student") {
      if (checked) {
        setEnrolled_student([
          { id: value, name: name, type: "enrolled_student" },
        ]);
      } else {
        setEnrolled_student(
          enrolled_student.filter((item) => item.id !== value)
        );
      }
    }
    if (typename === "payment_mode") {
      if (checked) {
        setpayment_mode([
          ...payment_mode,
          { id: value, name: name, type: "payment_mode" },
        ]);
      } else {
        setpayment_mode(payment_mode.filter((item) => item.id !== value));
      }

      // setpayment_mode((prev) => {
      //   if (checked) {
      //     // Add the selected checkbox value if it's checked
      //     return [{ id: value, name: name, type: "payment_mode" }];
      //   } else {
      //     // Remove the unchecked value from the state
      //     return prev.filter((item) => item.id !== value);
      //   }
      // });
    } else if (typename === "delivery_mode") {
      if (checked) {
        setDelivery_mode([{ id: value, name: name, type: "delivery_mode" }]);
      } else {
        setDelivery_mode(delivery_mode.filter((item) => item.id !== value));
      }
    } else if (typename === "delivery_status") {
      if (checked) {
        setDelivery_status([
          ...delivery_status,
          { id: value, name: name, type: "delivery_status" },
        ]);
      } else {
        setDelivery_status(delivery_status.filter((item) => item.id !== value));
      }
    } else if (typename === "branch_location_name") {
      if (checked) {
        // set_branch_location_name([{ id: value, name: name, type: "branch_location_name" }]);
        set_branch_location_name((prev) => [
          ...prev,
          { id: value, name: name, type: "branch_location_name" },
        ]);
      } else {
        // set_branch_location_name(branch_location_name.filter((item) => item.id !== value));
        set_branch_location_name((prev) =>
          prev.filter((item) => item.id !== value)
        );
      }
    } else if (typename === "batch_name") {
      if (checked) {
        set_batch_name((prev) => [
          ...prev,
          { id: value, name: name, type: "batch_name" },
        ]);
      } else {
        set_batch_name((prev) => prev.filter((item) => item.id !== value));
      }
    }
  };

  const handleClear = (name, event) => {
    updateStateData();
    if (name === "payment_mode") {
      updateStateData();
      setpayment_mode([]);
      filterPayment = [];
      setIsOpen({
        ...isOpen,
        payment_mode: false,
      });
    } else if (name === "delivery_mode") {
      updateStateData();
      setDelivery_mode([]);
      filterDeliveryMode = [];
      setIsOpen({
        ...isOpen,
        delivery_mode: false,
      });
    } else if (name === "delivery_status") {
      updateStateData();
      setDelivery_status([]);
      filterDeliveryStatus = [];
      setIsOpen({
        ...isOpen,
        delivery_status: false,
      });
    } else if (name === "enrolled_student") {
      updateStateData();
      setEnrolled_student([]);
      filterEnrollStudent = [];
      setIsOpen({
        ...isOpen,
        enrolled_student: false,
      });
    } else if (name === "branch_location_name") {
      updateStateData();
      set_branch_location_name([]);
      filterBranchLocation = [];
      setIsOpen({
        ...isOpen,
        branch_location_name: false,
      });
    } else if (name === "batch_name") {
      updateStateData();
      set_batch_name([]);
      filterBatch = [];
      setIsOpen({
        ...isOpen,
        batch_name: false,
      });
    } else if (name === "appliedOns") {
      updateStateData();
      setAppDatas({
        FDate: "",
        TDate: "",
        Days: "",
      });
      setAppOns([]);
      filterApplyeds = [];
      setIsOpen({
        ...isOpen,
        startDates: false,
      });
    }
    setTimeout(() => {
      loadChipdata();
    }, 500);
  };

  const handleApplyFilter = (name, event) => {
    updateStateData();
    if (name === "enrolled_student") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        enrolled_student: false,
      });
    }
    if (name === "payment_mode") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        payment_mode: false,
      });
    }
    if (name === "delivery_mode") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        delivery_mode: false,
      });
    }
    if (name === "delivery_status") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        delivery_status: false,
      });
    }
    if (name === "branch_location_name") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        branch_location_name: false,
      });
    }
    if (name === "batch_name") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        batch_name: false,
      });
    } else if (name === "appliedOns") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        startDates: false,
      });
    }
  };

  let ListItem = styled("li")(({ theme }) => ({
    margin: theme.spacing(0.5),
  }));

  const handleAllClear = () => {
    setSearchTerm([]);
    setUpdateChipData([]);
    setpayment_mode([]);
    setDelivery_mode([]);
    setBatchList([]);
    set_batch_name([]);
    setEnrolled_student([]);
    setDelivery_status([]);
    set_branch_location_name([]);
    // loadListdata();
    setAppOns([]);
    setAppDatas({
      FDate: "",
      TDate: "",
      Days: "",
    });
  };

  const handleFilter = (e, boxName) => {
    if (boxName === "enrolled_student") {
      setIsOpen((prevState) => ({
        type: false,
        branch_location_name: false,
        delivery_status: false,
        delivery_mode: false,
        payment_mode: false,
        startDates: false,
        enrolled_student: !prevState.enrolled_student,
      }));
      setEnrolled_student(
        updateChipData.filter((ui) => ui.type === "enrolled_student")
      );
    } else if (boxName === "startDates") {
      setIsOpen((prevState) => ({
        type: false,
        enrolled_student: false,
        branch_location_name: false,
        delivery_mode: false,
        payment_mode: false,
        delivery_status: false,
        startDates: !prevState.startDates,
      }));
    } else if (boxName === "payment_mode") {
      setIsOpen((prevState) => ({
        type: false,
        enrolled_student: false,
        branch_location_name: false,
        delivery_mode: false,
        payment_mode: false,
        delivery_status: false,
        startDates: false,
        payment_mode: !prevState.payment_mode,
      }));
      setpayment_mode(
        updateChipData.filter((ui) => ui.type === "payment_mode")
      );
    } else if (boxName === "delivery_mode") {
      setIsOpen((prevState) => ({
        type: false,
        delivery_mode: !prevState.delivery_mode,
      }));
      setDelivery_mode(
        updateChipData.filter((ui) => ui.type === "delivery_mode")
      );
    } else if (boxName === "delivery_status") {
      setIsOpen((prevState) => ({
        type: false,
        enrolled_student: false,
        branch_location_name: false,
        delivery_mode: false,
        payment_mode: false,
        startDates: false,
        delivery_status: !prevState.delivery_status,
      }));
      setDelivery_status(
        updateChipData.filter((ui) => ui.type === "delivery_status")
      );
    } else if (boxName === "branch_location_name") {
      setIsOpen((prevState) => ({
        ...prevState,
        enrolled_student: false,
        payment_mode: false,
        delivery_mode: false,
        delivery_status: false,
        startDates: false,
        batch_name: false,
        branch_location_name: !prevState.branch_location_name,
      }));
      set_branch_location_name(
        updateChipData.filter((ui) => ui.type === "branch_location_name")
      );
    } else if (boxName === "batch_name") {
      setIsOpen((prevState) => ({
        ...prevState,
        enrolled_student: false,
        payment_mode: false,
        delivery_mode: false,
        delivery_status: false,
        startDates: false,
        branch_location_name: false,
        batch_name: !prevState.batch_name,
      }));
      set_batch_name(updateChipData.filter((ui) => ui.type === "batch_name"));
    }
  };

  function getAPCSData(data) {
    if (data.length > 0) {
      const seenBranchIds = new Set();
      const batchIds = new Set();
      const branchLocation = data
        .filter((es) => {
          if (seenBranchIds.has(es.branch_location)) {
            return false;
          } else {
            seenBranchIds.add(es.branch_location);
            return true;
          }
        })
        .map((es) => ({
          branch_location_name: es.branch_location_name,
          branch_location: es.branch_location,
        }));

      setBranch(branchLocation);
      const batchName = data
        .filter((es) => {
          // Exclude entries with null batch_name or batch_id
          if (!es.batch_name || !es.batch_id) return false;

          if (batchIds.has(es.batch_name)) {
            return false;
          } else {
            batchIds.add(es.batch_name);
            return true;
          }
        })
        .map((es) => ({
          batch_name: es.batch_name,
          batch_id: es.batch_id,
        }));
      setBatchList(batchName);
    }
  }

  function loadListdata() {
    let tempEnrollStudent = [];
    let tempPaymentMode = [];
    let tempDeliveryMode = [];
    let tempDeliveryStatus = [];
    let tempBranchLocation = [];
    let tempBatch = [];
    enrolled_student.map((obj) => {
      tempEnrollStudent.push(obj.id);
    });
    payment_mode.map((obj) => {
      tempPaymentMode.push(obj.id);
    });
    delivery_mode.map((obj) => {
      tempDeliveryMode.push(obj.id);
    });
    delivery_status.map((obj) => {
      tempDeliveryStatus.push(parseInt(obj.id));
    });
    branch_location_name.map((obj) => {
      tempBranchLocation.push(parseInt(obj.id));
    });
    batch_name.map((obj) => {
      tempBatch.push(parseInt(obj.id));
    });
    let statusFilter = {
      // type: typeOn.length > 0 ? parseInt(temptypeon[0]) : "",
      // category: category_on.length > 0 ? parseInt(tempcategory[0]) : "",

      // search: searchTerm
      search: searchTerm.length > 0 ? searchTerm : "",
      branch_location:
        branch_location_name.length > 0 ? tempBranchLocation : "",

      // payment_mode: payment_mode.map((cat) => parseInt(cat.id)) || "",
      payment_mode: payment_mode.length > 0 ? tempPaymentMode : "",
      delivery_mode: delivery_mode.length > 0 ? tempDeliveryMode : "",
      delivery_status: delivery_status.length > 0 ? tempDeliveryStatus : "",
      enrolled_student:
        enrolled_student.length > 0 ? parseInt(tempEnrollStudent[0]) : "",
      branch_id: location_id, // location id need to change
      start_date: appOns.length > 0 ? appOns[0].fdate || appOns[0].FDate : "",
      end_date: appOns.length > 0 ? appOns[0].edate || appOns[0].TDate : "",
      batch_id: batch_name.length > 0 ? tempBatch : "",
    };
    setIsLoading(true);
    AxiosInstance.post("/api/book/purchase/list", statusFilter)
      .then((res) => {
        if (res.data.status) {
          setIsLoading(false);
          const fiata = res.data.data;
          setCurrentPage(1);
          const serialNumberAddedData = fiata.map((data, index) => ({
            ...data,
            serialNumber: index + 1,
          }));
          const csvFormattedData = serialNumberAddedData.map((item) => ({
            serialNumber: item.serialNumber,
            purchase_id: item.purchase_id,
            username: item.username,
            email: item.email,
            phone_no: item.phone_no,
            total_amount: item.total_amount,
            batch_name: item.batch_name ?? "-",
            payment_mode:
              item.payment_mode === 1
                ? "Online"
                : item.payment_mode === 2
                ? "QR Cash"
                : item.payment_mode === 3
                ? "Free"
                : "Cash",
            delivery_mode:
              item.delivery_mode === 0 ? "Branch Pickup" : "Courier Delivery",
            branch_location_name: item.branch_location_name,
            delivery_status_name: item.delivery_status_name,
            enrolled_student: item.enrolled_student === 0 ? "No" : "Yes",
            date: moment(item.date).utc().format("DD/MM/YYYY hh:mm:ss a"),
          }));
          // Set CSV data
          setCsvData(csvFormattedData);
          setUpdateListData(serialNumberAddedData);
          getAPCSData(serialNumberAddedData);
          const uniqueDeliveryStatus = Array.from(
            new Map(
              serialNumberAddedData?.length > 0 &&
                serialNumberAddedData.map((item) => [
                  item.delivery_status,
                  {
                    delivery_status: item.delivery_status,
                    delivery_status_name: item.delivery_status_name,
                  },
                ])
            ).values()
          );
          setDupData(uniqueDeliveryStatus);
        } else if (res.data.status === false) {
          setUpdateListData([]);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        setUpdateListData([]);
        setIsLoading(false);
        return error;
      });
  }

  let filterPayment = [];
  let filterDeliveryMode = [];
  let filterDeliveryStatus = [];
  let filterEnrollStudent = [];
  let filterApplyeds = [];

  let filterBranchLocation = [];
  let filterBatch = [];
  useEffect(() => {
    filterPayment = payment_mode;
  }, [payment_mode]);
  useEffect(() => {
    filterDeliveryMode = delivery_mode;
  }, [delivery_mode]);
  useEffect(() => {
    filterDeliveryStatus = delivery_status;
  }, [delivery_status]);
  useEffect(() => {
    filterEnrollStudent = enrolled_student;
  }, [enrolled_student]);
  useEffect(() => {
    filterBranchLocation = branch_location_name;
  }, [branch_location_name]);
  // useEffect(() => {
  //   filterApplyeds = appOns;
  // }, [appDatas]);

  function loadChipdata() {
    let tempArr = [];
    filterSearch.map((obj) => {
      tempArr.push(obj);
    });
    filterPayment.map((obj) => {
      tempArr.push(obj);
    });
    filterDeliveryMode.map((obj) => {
      tempArr.push(obj);
    });
    filterDeliveryStatus.map((obj) => {
      tempArr.push(obj);
    });
    filterEnrollStudent.map((obj) => {
      tempArr.push(obj);
    });
    filterBranchLocation.map((obj) => {
      tempArr.push(obj);
    });
    filterBatch.map((obj) => {
      tempArr.push(obj);
    });
    filterApplyeds.map((obj) => {
      tempArr.push(obj);
    });
    setUpdateChipData(tempArr);
  }

  // filter clear button

  // //   checking once again  -  handle delete function
  const handleDelete = useCallback((chipToDelete, index) => () => {
    updateStateData();
    if (chipToDelete.type === "search") {
      setSearchTerm("");
      filterSearch = [];
    }
    if (chipToDelete.type === "payment_mode") {
      setpayment_mode(
        payment_mode.filter((item) => item.id !== chipToDelete.id)
      );
      filterPayment = payment_mode.filter(
        (item) => item.id !== chipToDelete.id
      );
    } else if (chipToDelete.type === "delivery_mode") {
      setDelivery_mode(
        delivery_mode.filter((item) => item.id !== chipToDelete.id)
      );
      filterDeliveryMode = delivery_mode.filter(
        (item) => item.id !== chipToDelete.id
      );
    } else if (chipToDelete.type === "delivery_status") {
      setDelivery_status(
        delivery_status.filter((item) => item.id !== chipToDelete.id)
      );
      filterDeliveryStatus = delivery_status.filter(
        (item) => item.id !== chipToDelete.id
      );
    } else if (chipToDelete.type === "branch_location_name") {
      set_branch_location_name(
        branch_location_name.filter((item) => item.id !== chipToDelete.id)
      );
      filterBranchLocation = branch_location_name.filter(
        (item) => item.id !== chipToDelete.id
      );
    } else if (chipToDelete.type === "batch_name") {
      set_batch_name(batch_name.filter((item) => item.id !== chipToDelete.id));
      filterBatch = batch_name.filter((item) => item.id !== chipToDelete.id);
    } else if (chipToDelete.type === "enrolled_student") {
      setEnrolled_student([]);
      filterEnrollStudent = [];
      setEnrolled_student(
        enrolled_student.filter((item) => item.id !== chipToDelete.id)
      );
      filterEnrollStudent = enrolled_student.filter(
        (item) => item.id !== chipToDelete.id
      );
    } else if (chipToDelete.type === "dayRanges") {
      setAppDatas({
        FDate: "",
        TDate: "",
        Days: "",
      });
      setAppOns([]);
      filterApplyeds = [];
    } else {
      setAppDatas({
        FDate: "",
        TDate: "",
        Days: "",
      });
      setAppOns([]);
      filterApplyeds = [];
    }
    loadChipdata();
  });

  // total table data  with pages
  const totalPages = Math.ceil(updateListData?.length / rowsPerPage);

  // prev button pagination
  const handlePrev = (val) => {
    setCurrentPage(val);
  };
  // next button pagination
  const handleNext = (val) => {
    setCurrentPage(val);
  };

  const handlePageCount = (e) => {
    setRowsPerPage(Number(e.target.value));
    setCurrentPage(1);
    setUpdateListData([]);
    loadListdata();
  };
  // pagination start end -   item per page changing
  const start = (currentPage - 1) * rowsPerPage;
  const end = start + rowsPerPage;
  // const currentData = csvListData.slice(start, end);

  const currentData = updateListData?.slice(start, end);
  useEffect(() => {
    if (location.state) {
      // Optionally do something here if needed
    }
  }, [location.state]);

  useEffect(() => {
    if (location.state) {
      navigate(location.pathname, {
        replace: true,
        state: {},
      });
    }
  }, []);
  useEffect(() => {
    if (paymentMode && paymentMode.length > 0) {
      setpayment_mode(paymentMode);
      filterPayment = paymentMode;
    } else {
      setpayment_mode(payment_mode);
      filterPayment = payment_mode;
    }
    if (deliveryMode && deliveryMode.length > 0) {
      setDelivery_mode(deliveryMode);
      filterDeliveryMode = deliveryMode;
    } else {
      setDelivery_mode(delivery_mode);
      filterDeliveryMode = delivery_mode;
    }
    if (enrolledStudent && enrolledStudent.length > 0) {
      setEnrolled_student(enrolledStudent);
      filterEnrollStudent = enrolledStudent;
    } else {
      setEnrolled_student(enrolled_student);
      filterEnrollStudent = enrolled_student;
    }
    if (BranchLocation && BranchLocation.length > 0) {
      set_branch_location_name(BranchLocation);
      filterBranchLocation = BranchLocation;
    } else {
      set_branch_location_name(branch_location_name);
      filterBranchLocation = branch_location_name;
    }
    if (batchName && batchName.length > 0) {
      set_batch_name(batchName);
      filterBatch = batchName;
    } else {
      set_batch_name(batch_name);
      filterBatch = batch_name;
    }
    if (deliveryStatus && deliveryStatus.length > 0) {
      setDelivery_status(deliveryStatus);
      filterDeliveryStatus = deliveryStatus;
    } else {
      setDelivery_status([
        { id: "0", name: "Pickup Pending", type: "delivery_status" },
      ]);
      filterDeliveryStatus = [
        { id: "0", name: "Pickup Pending", type: "delivery_status" },
      ];
    }
    if (filter_date && filter_date.length > 0) {
      const filterDates = filter_date[0];
      setAppDatas({
        FDate: filterDates.fdate,
        TDate: filterDates.edate,
        Days: filterDates.Days,
        name: "",
      });
      setAppOns(filter_date);
      filterApplyeds = filter_date;
    }

    if (fillSearch && fillSearch.length > 0) {
      filterSearch = [{ name: "" + fillSearch, type: "search" }];
      setSearchTerm(fillSearch);
    } else {
      if (searchTerm) {
        // setSearchTerm(status);
        filterSearch = [{ name: "" + searchTerm, type: "search" }];
      }
    }
    setIsFiltersInitialized(true);
    loadChipdata();
  }, []);
  const [isFiltersInitialized, setIsFiltersInitialized] = useState(false);

  useEffect(() => {
    if (isFiltersInitialized && paymentMode && paymentMode.length > 0) {
      loadListdata();
    } else if (
      isFiltersInitialized &&
      deliveryMode &&
      deliveryMode.length > 0
    ) {
      loadListdata();
    } else if (
      isFiltersInitialized &&
      enrolledStudent &&
      enrolledStudent.length > 0
    ) {
      loadListdata();
    } else if (
      isFiltersInitialized &&
      BranchLocation &&
      BranchLocation.length > 0
    ) {
      loadListdata();
    } else if (isFiltersInitialized && batchName && batchName.length > 0) {
      loadListdata();
    } else if (
      isFiltersInitialized &&
      deliveryStatus &&
      deliveryStatus.length > 0
    ) {
      loadListdata();
    } else if (isFiltersInitialized && fillSearch && fillSearch.length > 0) {
      loadListdata();
    }
  }, [
    paymentMode,
    deliveryMode,
    enrolledStudent,
    BranchLocation,
    batchName,
    deliveryStatus,
    fillSearch,
    isFiltersInitialized,
    updateChipData,
  ]);
  useEffect(() => {
    if (isFiltersInitialized) {
      loadListdata();
    }
  }, [isFiltersInitialized, updateChipData]);

  // --------New code (Search Icon)----
  const handleSearchFocus = () => {
    if (txtBSearch.current) {
      txtBSearch.current.focus();

      // Create a new KeyboardEvent
      const event = new KeyboardEvent("keydown", {
        key: "Enter",
        keyCode: 13,
        which: 13,
        code: "Enter",
        bubbles: true,
      });

      // Dispatch the event
      txtBSearch.current.dispatchEvent(event);
    }
  };

  const handleView = (id) => {
    const formattedAppOns = appOns.map((item) => ({
      name:
        item.name ||
        (item.FDate && item.TDate ? `${item.FDate} - ${item.TDate}` : ""),
      fdate: item.fdate || item.FDate,
      edate: item.edate || item.TDate,
      type: item.type || "dateRange",
    }));
    navigate(`/ViewPurchase/${id}`, {
      state: {
        PAYMENT_MODE: payment_mode,
        DELIVERY_MODE: delivery_mode,
        BRANCH_LOCATION: branch_location_name,
        BATCH_NAME: batch_name,
        DELIVERY_STATUS: delivery_status,
        ENROLL_STUDENT: enrolled_student,
        SEARCH_TERM: searchTerm,
        DATE: formattedAppOns,
      },
    });
  };
  const dispatch = useDispatch();
  const handleNewFilter = () => {
    dispatch(resetSetFilters());
    navigate(`/AddPurchase`);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      const isCheckbox = event.target.closest('input[type="checkbox"]');
      const isApplyFilterButton = event.target.closest(".filterBoxs_testlist");
      const isChipData = event.target.closest(".paperil_global");
      if (isCheckbox || isApplyFilterButton || isChipData) return;
      if (
        filterRef_delivery_mode.current &&
        !filterRef_delivery_mode.current.contains(event.target)
      ) {
        {
          const hasAuthor = updateChipData.some(
            (chipItem) => chipItem.type === "delivery_mode"
          );
          if (hasAuthor) {
            const updatedAuthor = updateChipData.filter(
              (chipItem) => chipItem.type === "delivery_mode"
            );
            setDelivery_mode(updatedAuthor);
          } else {
            setDelivery_mode([]);
          }
          setIsOpen((prev) => ({ ...prev, delivery_mode: false }));
        }
      }
      if (
        filterRef_payment_mode.current &&
        !filterRef_payment_mode.current.contains(event.target)
      ) {
        {
          const hasAuthor = updateChipData.some(
            (chipItem) => chipItem.type === "payment_mode"
          );
          if (hasAuthor) {
            const updatedAuthor = updateChipData.filter(
              (chipItem) => chipItem.type === "payment_mode"
            );
            setpayment_mode(updatedAuthor);
          } else {
            setpayment_mode([]);
          }
          setIsOpen((prev) => ({ ...prev, payment_mode: false }));
        }
      }
      // if (
      //   filterLastRef.current &&
      //   !filterLastRef.current.contains(event.target)
      // ) {
      //   const mismatchedDay = updateChipData.find(
      //     (chipItem) => chipItem.Days && chipItem.Days === appDatas.Days
      //   );
      //   if (mismatchedDay) {
      //     setAppDatas({
      //       FDate: "",
      //       TDate: "",
      //       Days: mismatchedDay.Days,
      //     });
      //     setAppOns([
      //       {
      //         name: mismatchedDay.name || "",
      //         FDate: "",
      //         TDate: "",
      //         Days: mismatchedDay.Days,
      //       },
      //     ]);
      //   } else {
      //     const mismatchedDate = updateChipData.find(
      //       (chipItem) =>
      //         chipItem.fdate === appDatas.FDate &&
      //         chipItem.edate === appDatas.TDate
      //     );
      //     if (mismatchedDate) {
      //       setAppDatas((prev) => ({
      //         ...prev,
      //         FDate: mismatchedDate.fdate,
      //         TDate: mismatchedDate.edate,
      //         Days: "",
      //       }));
      //       setAppOns([
      //         {
      //           name:
      //             mismatchedDate.name ||
      //             `${mismatchedDate.fdate} - ${mismatchedDate.edate}`,
      //           FDate: mismatchedDate.fdate,
      //           TDate: mismatchedDate.edate,
      //           Days: "",
      //         },
      //       ]);
      //     } else {
      //       setAppDatas({
      //         FDate: "",
      //         TDate: "",
      //         Days: "",
      //       });
      //       setAppOns([]);
      //     }
      //   }
      //   setIsOpen((prev) => ({ ...prev, startDates: false }));
      // }
      if (
        filterRef_delivery_status.current &&
        !filterRef_delivery_status.current.contains(event.target)
      ) {
        const hasDeliveryStatus = updateChipData.some(
          (chipItem) => chipItem.type === "delivery_status"
        );

        if (hasDeliveryStatus) {
          const updatedDeliveryStatus = updateChipData.filter(
            (chipItem) => chipItem.type === "delivery_status"
          );
          setDelivery_status(updatedDeliveryStatus);
        } else {
          setDelivery_status([]);
        }

        setIsOpen((prev) => ({ ...prev, delivery_status: false }));
      }

      if (
        filterRef_branch_location.current &&
        !filterRef_branch_location.current.contains(event.target)
      ) {
        const hasBranch = updateChipData.some(
          (chipItem) => chipItem.type === "branch_location_name"
        );

        if (hasBranch) {
          const updatedBranch = updateChipData.filter(
            (chipItem) => chipItem.type === "branch_location_name"
          );
          set_branch_location_name(updatedBranch);
        } else {
          set_branch_location_name([]);
        }

        setIsOpen((prev) => ({ ...prev, branch_location_name: false }));
      }
      if (
        filterRef_batch_name.current &&
        !filterRef_batch_name.current.contains(event.target)
      ) {
        const hasBranch = updateChipData.some(
          (chipItem) => chipItem.type === "batch_name"
        );

        if (hasBranch) {
          const updatedBranch = updateChipData.filter(
            (chipItem) => chipItem.type === "batch_name"
          );
          set_batch_name(updatedBranch);
        } else {
          set_batch_name([]);
        }

        setIsOpen((prev) => ({ ...prev, batch_name: false }));
      }
      if (
        filterRef_enrolled_student.current &&
        !filterRef_enrolled_student.current.contains(event.target)
      ) {
        const hasStudent = updateChipData.some(
          (chipItem) => chipItem.type === "enrolled_student"
        );

        if (hasStudent) {
          const updatedStudent = updateChipData.filter(
            (chipItem) => chipItem.type === "enrolled_student"
          );
          setEnrolled_student(updatedStudent);
        } else {
          setEnrolled_student([]);
        }

        setIsOpen((prev) => ({ ...prev, enrolled_student: false }));
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [updateChipData, delivery_mode, payment_mode]);

  // date picker filter
  const handleAppliedOns = (e) => {
    const { name, value, checked } = e.target;
    if (name === "FDate" || name === "TDate") {
      setAppDatas((prevState) => {
        const updated = {
          ...prevState,
          [name]: value,
          Days: "", // Reset Days when FDate or TDate is changed
        };
        const from = name === "FDate" ? value : updated.FDate;
        const to = name === "TDate" ? value : updated.TDate;
        if (from && to) {
          const dateRange = `${from} - ${to}`;
          setAppOns([
            {
              name: dateRange,
              fdate: moment(from).format("YYYY-MM-DD"),
              edate: moment(to).format("YYYY-MM-DD"),
              type: "dateRanges",
              Days: "",
            },
          ]);
        } else {
          setAppOns([
            {
              name: "",
              fdate: "",
              edate: "",
              type: "dateRanges",
              Days: "",
            },
          ]);
        }
        return updated;
      });
    } else if (name === "Days") {
      if (checked) {
        // Set Days and reset FDate/TDate
        setAppDatas({
          FDate: "",
          TDate: "",
          Days: value,
        });
        const today = new Date();
        let fdate = "";
        let edate = "";
        let label = "";
        if (value === "Today") {
          fdate = edate = moment(today).format("YYYY-MM-DD");
          label = "Today";
        } else if (value === "Yesterday") {
          const yesterday = new Date(today);
          yesterday.setDate(yesterday.getDate() - 1);
          fdate = edate = moment(yesterday).format("YYYY-MM-DD");
          label = "Yesterday";
        } else if (value === "Tweek") {
          const start = moment(today).startOf("week").toDate();
          const end = moment(today).endOf("week").toDate();
          fdate = moment(start).format("YYYY-MM-DD");
          edate = moment(end).format("YYYY-MM-DD");
          label = "This week";
        } else if (value === "Lweek") {
          const start = moment(today)
            .subtract(1, "week")
            .startOf("week")
            .toDate();
          const end = moment(today).subtract(1, "week").endOf("week").toDate();
          fdate = moment(start).format("YYYY-MM-DD");
          edate = moment(end).format("YYYY-MM-DD");
          label = "Last week";
        } else if (value === "Tmonth") {
          const start = new Date(today.getFullYear(), today.getMonth(), 1);
          const end = new Date(today.getFullYear(), today.getMonth() + 1, 0);
          fdate = moment(start).format("YYYY-MM-DD");
          edate = moment(end).format("YYYY-MM-DD");
          label = "This month";
        } else if (value === "Lmonth") {
          const start = new Date(today.getFullYear(), today.getMonth() - 1, 1);
          const end = new Date(today.getFullYear(), today.getMonth(), 0);
          fdate = moment(start).format("YYYY-MM-DD");
          edate = moment(end).format("YYYY-MM-DD");
          label = "Last month";
        }
        setAppOns([
          {
            name: label,
            fdate,
            edate,
            type: "dayRanges",
            Days: value,
          },
        ]);
      }
    }
  };
  const handleChangeDate_app = (date, name) => {
    const dateFilter = moment(date).format("YYYY-MM-DD");

    if (name === "FDate" || name === "TDate") {
      setAppDatas((prevState) => {
        const updated = {
          ...prevState,
          [name]: dateFilter,
          Days: "",
        };
        const from = name === "FDate" ? dateFilter : updated.FDate;
        const to = name === "TDate" ? dateFilter : updated.TDate;
        if (from && to) {
          const dateRange = `${from} - ${to}`;
          setAppOns([
            {
              name: dateRange,
              fdate: moment(from).format("YYYY-MM-DD"),
              edate: moment(to).format("YYYY-MM-DD"),
              type: "dateRange",
              Days: "",
            },
          ]);
        }

        return updated;
      });
    }
  };

  const generatePDF = () => {
    const headers = [
      "Order ID",
      "User Name",
      "Amount Paid",
      "Payment Mode",
      "Delivery Mode",
      "Created date & Time",
    ];

    const rows = csvData.map((item, index) => [
      item.purchase_id ?? "",
      item.username ?? "",
      item.total_amount ?? "",
      item.payment_mode ?? "",
      item.delivery_mode ?? "",
      item.date ?? "-",
    ]);

    if (rows.length <= 500) {
      navigate("/preview", {
        state: {
          title: "List Purchase Data",
          headers,
          rows,
          filename: "ListPurchase.pdf",
          autoPrint: true,
        },
      });
    } else {
      toast.error(
        "The PDF cannot be generated because the data exceeds 500 records. Please apply filters and try again."
      );
    }
  };

  const csvHeaders = [
    { label: "S.No", key: "serialNumber" },
    { label: "Order ID", key: "purchase_id" },
    { label: "User Name", key: "username" },
    { label: "Email", key: "email" },
    { label: "Phone No", key: "phone_no" },
    { label: "Amount Paid", key: "total_amount" },
    { label: "Batch Name", key: "batch_name" },
    { label: "Payment Mode", key: "payment_mode" },
    { label: "Delivery Mode", key: "delivery_mode" },
    { label: "Branch Location", key: "branch_location_name" },
    { label: "Delivery Status", key: "delivery_status_name" },
    { label: "Enrolled Student", key: "enrolled_student" },
    { label: "Created Date & Time", key: "date" },
  ];

  return isLoading ? (
    <div
      className="loaderApi"
      style={{
        display: isLoading ? "flex" : "none",
        justifyContent: "center",
        alignItems: "center",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "white",
        zIndex: 999,
      }}
    >
      {isLoading && <Loader />}
    </div>
  ) : (
    <div
      className={`${ListInfo.CourseInfoSec} ${styles.cm_ListViewForm} container-fluid BathHeader BathDet  global_container p-0`}
    >
      <div className="col-md-6 col-12">
        <h2 className="TitleHeader">Sales</h2>
      </div>
      {/* ---------------------------------------------------------------- */}

      <div className="row ">
        <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-2">
          <div class="input-group ">
            <input
              ref={txtBSearch}
              type="text"
              class={styles.Inputs}
              id="SearchInput"
              name="SearchInput"
              placeholder="Search by Order ID, Name, Phone Number, or Email ID"
              onKeyDown={handleSearch}
            />
            <span
              class={styles.input_group_text}
              id="SearchInput"
              onClick={handleSearchFocus}
            >
              <span
                className="material-icons"
                // onClick={handleSearchFocus}
              >
                search
              </span>
            </span>
          </div>
        </div>

        <div className="col-md-8 col-12 ListBtn">
          <ul class="List-Button">
            <li class="ListBtnItems">
              <CustomDownloadButton
                csvListData={csvData?.length > 0 ? csvData : ""}
                headers={csvHeaders}
                iconName=" file_download "
                filename={"ListPurchase.csv"}
                csvName="Download as CSV"
              />
            </li>
            <li class="ListBtnItems primaryButton" onClick={generatePDF}>
              <span className="material-icons me-1 align-middle text-white">
                file_download
              </span>
              Download as PDF
            </li>
            <li class="ListBtnItems">
              <Link
                onClick={() => handleNewFilter()}
                to="javascript:void(0)"
                className="primaryButton "
                variant="primary"
              >
                Create New Sales
              </Link>
            </li>
          </ul>
        </div>
      </div>
      {updateChipData.filter((kl) => kl.name !== "ActiveTab").length > 0 ? (
        <div className="row mt-3">
          <div className="col-md-12 col-sm-12 col-xs-12 paperil_global">
            <Paper
              sx={{
                display: "flex",
                justifyContent: "center",
                flexWrap: "wrap",
                listStyle: "none",
                p: 0.5,
                m: 0,
              }}
              component="ul"
            >
              {updateChipData
                .filter((kl) => kl.name !== "ClearFilter")
                .map((data, index) => {
                  let key = "";
                  if (data.name === "Pickup Pending") {
                    key = "" + "Pickup Pending";
                  } else {
                    key = "" + data.name;
                  }
                  let icon;
                  return (
                    <ListItem key={index}>
                      <Chip
                        icon={icon}
                        label={key}
                        onDelete={handleDelete(data, index)}
                      />
                    </ListItem>
                  );
                })}

              <ListItem className="clearAll_list">
                <a
                  className={"clearAll_listItem"}
                  href="javascript:void(0)"
                  onClick={handleAllClear}
                >
                  Clear All Filters
                </a>
              </ListItem>
            </Paper>
          </div>
        </div>
      ) : (
        <div></div>
      )}

      <div className="row mt-2 mx-0">
        <div className="col-md-12 table-responsive tableMinHeight px-0">
          <table className="table" id="tableListHeader">
            <thead>
              <tr>
                <th id="th">
                  <span
                    onClick={(e) => handleSort(e, "serialNumber")}
                    className="textHead_th"
                  >
                    S.No
                  </span>
                  <span
                    className={`textHead_th material-icons align-middle`}
                    onClick={(e) => handleSort(e, "serialNumber")}
                  >
                    import_export{" "}
                  </span>
                </th>
                <th id="th">
                  <span
                    className="textHead_th"
                    onClick={(e) => handleSort(e, "purchase_id")}
                  >
                    {" "}
                    Order ID
                  </span>
                  <span
                    className={`material-icons textHead_th align-middle`}
                    onClick={(e) => handleSort(e, "purchase_id")}
                  >
                    import_export
                  </span>{" "}
                </th>
                <th id="th">
                  <span
                    className="textHead_th"
                    onClick={(e) => handleSort(e, "username")}
                  >
                    {" "}
                    User Name
                  </span>
                  <span
                    className={`material-icons textHead_th align-middle`}
                    onClick={(e) => handleSort(e, "username")}
                  >
                    import_export
                  </span>{" "}
                </th>
                <th id="th">
                  <span
                    className="textHead_th"
                    onClick={(e) => handleSort(e, "email")}
                  >
                    {" "}
                    Email ID
                  </span>
                  <span
                    className={`material-icons textHead_th align-middle`}
                    onClick={(e) => handleSort(e, "email")}
                  >
                    import_export
                  </span>{" "}
                </th>
                <th id="th">
                  <span
                    className="textHead_th"
                    onClick={(e) => handleSort(e, "phone_no")}
                  >
                    {" "}
                    Phone Number
                  </span>
                  <span
                    className={`material-icons textHead_th align-middle`}
                    onClick={(e) => handleSort(e, "phone_no")}
                  >
                    import_export
                  </span>{" "}
                </th>
                <th id="th">
                  <span
                    className="textHead_th"
                    onClick={(e) => handleSort(e, "total_amount")}
                  >
                    {" "}
                    Amount Paid
                  </span>
                  <span
                    className={`material-icons textHead_th align-middle`}
                    onClick={(e) => handleSort(e, "total_amount")}
                  >
                    import_export
                  </span>{" "}
                </th>
                <th id={"th"} ref={filterRef_batch_name}>
                  <span
                    className="text_th"
                    onClick={(e) => handleSort(e, "delivery_mode")}
                  >
                    Batch Name
                  </span>
                  <span
                    className={` material-icons align-middle`}
                    onClick={(e) => handleSort(e, "branch_location_name")}
                  >
                    import_export
                  </span>
                  <span
                    class={` textHead_th align-middle material-icons ${
                      batch_name.length > 0 || isOpen.batch_name
                        ? styles.active_icons_book
                        : ""
                    }`}
                    onClick={(e) => handleFilter(e, "batch_name")}
                  >
                    filter_list
                  </span>
                  {isOpen.batch_name && (
                    <>
                      <div className="filterBoxs_testlist mt-3">
                        <div className="col-md-12 form-check filterStatus_list">
                          <ul className="ulFilterListData">
                            {batchList.map((el) => (
                              <li className="filterListData">
                                <input
                                  className="ListCheckbox"
                                  type="checkbox"
                                  name={el.batch_name}
                                  value={el.batch_id}
                                  id={el.batch_name}
                                  checked={batch_name.some((element) => {
                                    if (element.id == el.batch_id) {
                                      return true;
                                    }
                                  })}
                                  onChange={(e) =>
                                    handleCheckboxChange(
                                      e,
                                      el.batch_name,
                                      "batch_name"
                                    )
                                  }
                                />
                                <label
                                  className="form-check-label filterChipText_withoutBG "
                                  htmlFor={el.batch_name}
                                >
                                  {el.batch_name}
                                </label>
                              </li>
                            ))}
                          </ul>
                        </div>
                        <div className="borderWidth row">
                          <ul className="List-Button">
                            <li className="ListBtnItems">
                              <Link
                                to={"javascript:void(0)"}
                                onClick={() => handleClear("batch_name")}
                                className="secondaryButton "
                              >
                                Clear
                              </Link>
                            </li>
                            <li className="ListBtnItems">
                              <Link
                                disabled={
                                  batch_name.length === 0 ? true : false
                                }
                                onClick={() => handleApplyFilter("batch_name")}
                                className="primaryButton"
                              >
                                Apply Filter
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </>
                  )}
                </th>
                <th id={"th"} ref={filterRef_payment_mode}>
                  <span
                    className="text_th"
                    onClick={(e) => handleSort(e, "payment_mode")}
                  >
                    Payment Mode
                  </span>
                  <span
                    className={` material-icons align-middle`}
                    onClick={(e) => handleSort(e, "payment_mode")}
                  >
                    import_export
                  </span>
                  <span
                    class={` textHead_th align-middle material-icons ${
                      payment_mode.length > 0 || isOpen.payment_mode
                        ? styles.active_icons_book
                        : ""
                    }`}
                    onClick={(e) => handleFilter(e, "payment_mode")}
                  >
                    filter_list
                  </span>
                  {isOpen.payment_mode && (
                    <>
                      <div className="filterBoxs_testlist mt-3">
                        <div className="col-md-12 form-check filterStatus_list">
                          <ul className="ulFilterListData">
                            <li className="filterListData">
                              <input
                                className="ListCheckbox"
                                type="checkbox"
                                name={"Online"}
                                value={"1"}
                                checked={payment_mode.some((element) => {
                                  if (element.id == "1") {
                                    return true;
                                  }
                                  return false;
                                })}
                                id={"Online"}
                                onChange={(e) =>
                                  handleCheckboxChange(
                                    e,
                                    "payment_mode",
                                    "payment_mode"
                                  )
                                }
                              />
                              <label
                                className="form-check-label filterChipText_withoutBG "
                                htmlFor={"Online"}
                              >
                                Online
                              </label>
                            </li>
                            <li className="filterListData">
                              <input
                                className="ListCheckbox"
                                type="checkbox"
                                name={"Cash"}
                                value={"0"}
                                checked={payment_mode.some((element) => {
                                  if (element.id == "0") {
                                    return true;
                                  }
                                  return false;
                                })}
                                id={"Cash"}
                                onChange={(e) =>
                                  handleCheckboxChange(
                                    e,
                                    "payment_mode",
                                    "payment_mode"
                                  )
                                }
                              />
                              <label
                                className="form-check-label filterChipText_withoutBG "
                                htmlFor={"Cash"}
                              >
                                Cash
                              </label>
                            </li>
                            <li className="filterListData">
                              <input
                                className="ListCheckbox"
                                type="checkbox"
                                name={"QR Cash"}
                                value={"2"}
                                checked={payment_mode.some((element) => {
                                  if (element.id == "2") {
                                    return true;
                                  }
                                  return false;
                                })}
                                id={"QR Cash"}
                                onChange={(e) =>
                                  handleCheckboxChange(
                                    e,
                                    "payment_mode",
                                    "payment_mode"
                                  )
                                }
                              />
                              <label
                                className="form-check-label filterChipText_withoutBG "
                                htmlFor={"QR Cash"}
                              >
                                QR Cash
                              </label>
                            </li>
                            <li className="filterListData">
                              <input
                                className="ListCheckbox"
                                type="checkbox"
                                name={"Free"}
                                value={"3"}
                                checked={payment_mode.some((element) => {
                                  if (element.id == "3") {
                                    return true;
                                  }
                                  return false;
                                })}
                                id={"Free"}
                                onChange={(e) =>
                                  handleCheckboxChange(
                                    e,
                                    "payment_mode",
                                    "payment_mode"
                                  )
                                }
                              />
                              <label
                                className="form-check-label filterChipText_withoutBG "
                                htmlFor={"Free"}
                              >
                                Free
                              </label>
                            </li>
                          </ul>
                        </div>
                        <div className="borderWidth row">
                          <ul className="List-Button">
                            <li className="ListBtnItems">
                              <Link
                                to={"javascript:void(0)"}
                                onClick={() => handleClear("payment_mode")}
                                className="secondaryButton "
                              >
                                Clear
                              </Link>
                            </li>
                            <li className="ListBtnItems">
                              <Link
                                disabled={
                                  payment_mode.length === 0 ? true : false
                                }
                                onClick={() =>
                                  handleApplyFilter("payment_mode")
                                }
                                className="primaryButton"
                              >
                                Apply Filter
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </>
                  )}
                </th>
                <th id={"th"} ref={filterRef_delivery_mode}>
                  <span
                    className="text_th"
                    onClick={(e) => handleSort(e, "delivery_mode")}
                  >
                    Delivery Mode
                  </span>
                  <span
                    className={` material-icons align-middle`}
                    onClick={(e) => handleSort(e, "delivery_mode")}
                  >
                    import_export
                  </span>
                  <span
                    class={` textHead_th align-middle material-icons ${
                      delivery_mode.length > 0 || isOpen.delivery_mode
                        ? styles.active_icons_book
                        : ""
                    }`}
                    onClick={(e) => handleFilter(e, "delivery_mode")}
                  >
                    filter_list
                  </span>
                  {isOpen.delivery_mode && (
                    <>
                      <div className="filterBoxs_testlist mt-3">
                        <div className="col-md-12 form-check filterStatus_list">
                          <ul className="ulFilterListData">
                            <li className="filterListData">
                              <input
                                className="ListCheckbox"
                                type="checkbox"
                                name={" Courier Delivery"}
                                value={"1"}
                                checked={delivery_mode.some((element) => {
                                  if (element.id == "1") {
                                    return true;
                                  }
                                  return false;
                                })}
                                id={" Courier Delivery"}
                                onChange={(e) =>
                                  handleCheckboxChange(
                                    e,
                                    "delivery_mode",
                                    "delivery_mode"
                                  )
                                }
                              />
                              <label
                                className="form-check-label filterChipText_withoutBG "
                                htmlFor={" Courier Delivery"}
                              >
                                Courier Delivery
                              </label>
                            </li>
                            <li className="filterListData">
                              <input
                                className="ListCheckbox"
                                type="checkbox"
                                name={"  Branch Pickup"}
                                value={"0"}
                                checked={delivery_mode.some((element) => {
                                  if (element.id == "0") {
                                    return true;
                                  }
                                  return false;
                                })}
                                id={"  Branch Pickup"}
                                onChange={(e) =>
                                  handleCheckboxChange(
                                    e,
                                    "delivery_mode",
                                    "delivery_mode"
                                  )
                                }
                              />
                              <label
                                className="form-check-label filterChipText_withoutBG "
                                htmlFor={"  Branch Pickup"}
                              >
                                Branch Pickup
                              </label>
                            </li>
                          </ul>
                        </div>
                        <div className="borderWidth row">
                          <ul className="List-Button">
                            <li className="ListBtnItems">
                              <Link
                                to={"javascript:void(0)"}
                                onClick={() => handleClear("delivery_mode")}
                                className="secondaryButton "
                              >
                                Clear
                              </Link>
                            </li>
                            <li className="ListBtnItems">
                              <Link
                                disabled={
                                  delivery_mode.length === 0 ? true : false
                                }
                                onClick={() =>
                                  handleApplyFilter("delivery_mode")
                                }
                                className="primaryButton"
                              >
                                Apply Filter
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </>
                  )}
                </th>
                <th id={"th"} ref={filterRef_branch_location}>
                  <span
                    className="text_th"
                    onClick={(e) => handleSort(e, "delivery_mode")}
                  >
                    Branch Location
                  </span>
                  <span
                    className={` material-icons align-middle`}
                    onClick={(e) => handleSort(e, "branch_location_name")}
                  >
                    import_export
                  </span>
                  <span
                    class={` textHead_th align-middle material-icons ${
                      branch_location_name.length > 0 ||
                      isOpen.branch_location_name
                        ? styles.active_icons_book
                        : ""
                    }`}
                    onClick={(e) => handleFilter(e, "branch_location_name")}
                  >
                    filter_list
                  </span>
                  {isOpen.branch_location_name && (
                    <>
                      <div className="filterBoxs_testlist mt-3">
                        <div className="col-md-12 form-check filterStatus_list">
                          <ul className="ulFilterListData">
                            {branch.map((el) => (
                              <li className="filterListData">
                                <input
                                  className="ListCheckbox"
                                  type="checkbox"
                                  name={el.branch_location_name}
                                  value={el.branch_location}
                                  id={el.branch_location_name}
                                  checked={branch_location_name.some(
                                    (element) => {
                                      if (element.id == el.branch_location) {
                                        return true;
                                      }
                                    }
                                  )}
                                  onChange={(e) =>
                                    handleCheckboxChange(
                                      e,
                                      el.branch_location_name,
                                      "branch_location_name"
                                    )
                                  }
                                />
                                <label
                                  className="form-check-label filterChipText_withoutBG "
                                  htmlFor={el.branch_location_name}
                                >
                                  {el.branch_location_name}
                                </label>
                              </li>
                            ))}
                          </ul>
                        </div>
                        <div className="borderWidth row">
                          <ul className="List-Button">
                            <li className="ListBtnItems">
                              <Link
                                to={"javascript:void(0)"}
                                onClick={() =>
                                  handleClear("branch_location_name")
                                }
                                className="secondaryButton "
                              >
                                Clear
                              </Link>
                            </li>
                            <li className="ListBtnItems">
                              <Link
                                disabled={
                                  branch_location_name.length === 0
                                    ? true
                                    : false
                                }
                                onClick={() =>
                                  handleApplyFilter("branch_location_name")
                                }
                                className="primaryButton"
                              >
                                Apply Filter
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </>
                  )}
                </th>
                <th id={"th"} ref={filterRef_delivery_status}>
                  <span
                    className="text_th"
                    onClick={(e) => handleSort(e, "delivery_status")}
                  >
                    Delivery Status
                  </span>
                  <span
                    className={` material-icons align-middle`}
                    onClick={(e) => handleSort(e, "delivery_status")}
                  >
                    import_export
                  </span>

                  <span
                    class={` textHead_th align-middle material-icons ${
                      delivery_status.length > 0 || isOpen.delivery_status
                        ? styles.active_icons_book
                        : ""
                    }`}
                    onClick={(e) => handleFilter(e, "delivery_status")}
                  >
                    filter_list
                  </span>
                  {isOpen.delivery_status === true && (
                    <div className="filterBoxs_testlist">
                      <div className="col-md-12 form-check filterStatus_list">
                        <ul className="ulFilterListData">
                          {dupData?.map((el) => (
                            <li
                              className={`filterListData
                                }`}
                            >
                              <input
                                className="ListCheckbox"
                                type="checkbox"
                                name={el.delivery_status_name}
                                value={el.delivery_status}
                                id={el.delivery_status_name}
                                checked={delivery_status.some((element) => {
                                  if (element.id == el.delivery_status) {
                                    return true;
                                  }
                                  return false;
                                })}
                                onChange={(e) =>
                                  handleCheckboxChange(
                                    e,
                                    "delivery_status",
                                    "delivery_status"
                                  )
                                }
                              />
                              <label
                                className="form-check-label filterChipText_withoutBG "
                                htmlFor={el.delivery_status_name}
                              >
                                {el.delivery_status_name}
                              </label>
                            </li>
                          ))}
                          {/* <li className="filterListData">
                            <input
                              className="ListCheckbox"
                              type="checkbox"
                              name={"Pickup Pending"}
                              value={"0"}
                              checked={delivery_status.some((element) => {
                                console.log(element, "element----");

                                if (element.id == "0") {
                                  return true;
                                }
                                return false;
                              })}
                              id={"Pickup Pending"}
                              onChange={(e) =>
                                handleCheckboxChange(
                                  e,
                                  "delivery_status",
                                  "delivery_status"
                                )
                              }
                            />
                            <label
                              className="form-check-label filterChipText bg-blue"
                              htmlFor={"Pickup Pending"}
                            >
                              Pickup Pending
                            </label>
                          </li>
                          <li className="filterListData">
                            <input
                              className="ListCheckbox"
                              type="checkbox"
                              name={"  Shipping in Progress"}
                              value={"1"}
                              checked={delivery_status.some((element) => {
                                if (element.id == "1") {
                                  return true;
                                }
                                return false;
                              })}
                              id={"  Shipping in Progress"}
                              onChange={(e) =>
                                handleCheckboxChange(
                                  e,
                                  "delivery_status",
                                  "delivery_status"
                                )
                              }
                            />
                            <label
                              className="form-check-label filterChipText bg-orange "
                              htmlFor={"  Shipping in Progress"}
                            >
                              Shipping in Progress
                            </label>
                          </li>
                          <li className="filterListData">
                            <input
                              className="ListCheckbox"
                              type="checkbox"
                              name={"Delivered"}
                              value={"2"}
                              checked={delivery_status.some((element) => {
                                if (element.id == "2") {
                                  return true;
                                }
                                return false;
                              })}
                              id={"Delivered"}
                              onChange={(e) =>
                                handleCheckboxChange(
                                  e,
                                  "delivery_status",
                                  "delivery_status"
                                )
                              }
                            />
                            <label
                              className="form-check-label bg-green filterChipText  "
                              htmlFor={"Delivered"}
                            >
                              Delivered
                            </label>
                          </li>
                          <li className="filterListData">
                            <input
                              className="ListCheckbox"
                              type="checkbox"
                              name={"Undelivered"}
                              value={"3"}
                              checked={delivery_status.some((element) => {
                                if (element.id == "3") {
                                  return true;
                                }
                                return false;
                              })}
                              id={"Undelivered"}
                              onChange={(e) =>
                                handleCheckboxChange(
                                  e,
                                  "delivery_status",
                                  "delivery_status"
                                )
                              }
                            />
                            <label
                              className="form-check-label  filterChipText bg-pink "
                              htmlFor={"Undelivered"}
                            >
                              Undelivered
                            </label>
                          </li> */}
                        </ul>
                      </div>
                      <div className="borderWidth row">
                        <ul className="List-Button">
                          <li className="ListBtnItems">
                            <Link
                              to={"javascript:void(0)"}
                              onClick={() => handleClear("delivery_status")}
                              className="secondaryButton ms-2"
                            >
                              Clear
                            </Link>
                          </li>
                          <li className="ListBtnItems">
                            <Link
                              to={"javascript:void(0)"}
                              onClick={() =>
                                handleApplyFilter("delivery_status")
                              }
                              className="primaryButton"
                            >
                              Apply Filter
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                  )}
                </th>
                <th id={"th"} ref={filterRef_enrolled_student}>
                  <span
                    className="text_th"
                    onClick={(e) => handleSort(e, "enrolled_student")}
                  >
                    Enrolled Student
                  </span>
                  <span
                    className={` material-icons align-middle`}
                    onClick={(e) => handleSort(e, "enrolled_student")}
                  >
                    import_export
                  </span>
                  <span
                    class={` textHead_th align-middle material-icons ${
                      enrolled_student.length > 0 || isOpen.enrolled_student
                        ? styles.active_icons_book
                        : ""
                    }`}
                    onClick={(e) => handleFilter(e, "enrolled_student")}
                  >
                    filter_list
                  </span>
                  {isOpen.enrolled_student && (
                    <>
                      <div className="filterBoxs_testlist mt-3">
                        <div className="col-md-12 form-check filterStatus_list">
                          <ul className="ulFilterListData">
                            <li className="filterListData">
                              <input
                                className="ListCheckbox"
                                type="checkbox"
                                name={"Enrolled Student : Yes"}
                                value={"1"}
                                checked={enrolled_student.some((element) => {
                                  if (element.id == "1") {
                                    return true;
                                  }
                                  return false;
                                })}
                                id={"Yes"}
                                onChange={(e) =>
                                  handleCheckboxChange(
                                    e,
                                    "enrolled_student",
                                    "enrolled_student"
                                  )
                                }
                              />
                              <label
                                className="form-check-label filterChipText_withoutBG "
                                htmlFor={"Yes"}
                              >
                                Yes
                              </label>
                            </li>
                            <li className="filterListData">
                              <input
                                className="ListCheckbox"
                                type="checkbox"
                                name={"Enrolled Student : No"}
                                value={"0"}
                                checked={enrolled_student.some((element) => {
                                  if (element.id == "0") {
                                    return true;
                                  }
                                  return false;
                                })}
                                id={"No"}
                                onChange={(e) =>
                                  handleCheckboxChange(
                                    e,
                                    "enrolled_student",
                                    "enrolled_student"
                                  )
                                }
                              />
                              <label
                                className="form-check-label filterChipText_withoutBG "
                                htmlFor={"No"}
                              >
                                No
                              </label>
                            </li>
                          </ul>
                        </div>
                        <div className="borderWidth row">
                          <ul className="List-Button">
                            <li className="ListBtnItems">
                              <Link
                                to={"javascript:void(0)"}
                                onClick={() => handleClear("enrolled_student")}
                                className="secondaryButton "
                              >
                                Clear
                              </Link>
                            </li>
                            <li className="ListBtnItems">
                              <Link
                                disabled={
                                  enrolled_student.length === 0 ? true : false
                                }
                                onClick={() =>
                                  handleApplyFilter("enrolled_student")
                                }
                                className="primaryButton"
                              >
                                Apply Filter
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </>
                  )}
                </th>
                <th id="th" ref={filterLastRef}>
                  <span
                    className="textHead_th"
                    onClick={(e) => handleSort(e, "date")}
                  >
                    {" "}
                    Created Date & Time
                  </span>
                  <span
                    className={`material-icons textHead_th align-middle`}
                    onClick={(e) => handleSort(e, "date")}
                  >
                    import_export
                  </span>{" "}
                  <span
                    onClick={(e) => handleFilter(e, "startDates")}
                    class={` align-middle material-icons ${
                      (appDatas &&
                        Object.entries(appDatas).some(
                          ([key, val]) =>
                            key !== "name" &&
                            val !== null &&
                            val !== undefined &&
                            val.toString().trim() !== ""
                        )) ||
                      isOpen.startDates
                        ? styles.active_icons_book
                        : ""
                    }`}
                  >
                    filter_list
                  </span>
                  {isOpen.startDates && (
                    <div className="filterBoxs_testlist container  p-1">
                      <div className="row mt-1">
                        <div className="col-md-12">
                          <div class="form-check p-1">
                            <label
                              htmlFor="FDate"
                              className="d-flex form-label"
                            >
                              From Date
                              <span
                                data-required="true"
                                aria-hidden="true"
                              ></span>
                            </label>
                            <DatePickerSample
                              IconInput={"filterIocnBoxInput"}
                              class={"FilterInputs"}
                              name={"FDate"}
                              handleChange={handleChangeDate_app}
                              fieldInput={appDatas.FDate}
                              txtAdMDob={fDatePickerRef}
                              // maxDate={new Date()}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row mt-1">
                        <div className="col-md-12">
                          <div class="form-check p-1">
                            <label
                              htmlFor="TDate "
                              className="d-flex form-label"
                            >
                              To Date
                              <span
                                data-required="true"
                                aria-hidden="true"
                              ></span>
                            </label>
                            <DatePickerSample
                              class={"FilterInputs"}
                              IconInput={"filterIocnBoxInput"}
                              name={"TDate"}
                              handleChange={handleChangeDate_app}
                              fieldInput={appDatas.TDate}
                              txtAdMDob={tDatePickerRef}
                              minDate={appDatas.FDate}
                            />
                          </div>
                        </div>
                      </div>
                      {/* <div className="row mt-2">
                        <div className="col-md-6 col-6 col-sm-6 col-xs-6">
                          <div class="form-check">
                            <input
                              class="form-check-input"
                              type="radio"
                              name="Days"
                              id="Today"
                              value="Today"
                              checked={appDatas.Days === "Today"}
                              onChange={handleAppliedOns}
                            />
                            <label
                              class="form-check-label d-flex"
                              for="Today"
                              htmlFor="Today"
                              style={{ fontWeight: "bold" }}
                            >
                              Today
                            </label>
                          </div>
                        </div>
                        <div className="col-md-6 col-6 col-sm-6 col-xs-6">
                          <div class="form-check">
                            <input
                              class="form-check-input"
                              type="radio"
                              name="Days"
                              value="Yesterday"
                              checked={appDatas.Days === "Yesterday"}
                              id="Yesterday"
                              onChange={handleAppliedOns}
                            />
                            <label
                              class="form-check-label d-flex"
                              for="Yesterday"
                              htmlFor="Yesterday"
                              style={{ fontWeight: "bold" }}
                            >
                              Yesterday
                            </label>
                          </div>
                        </div>
                        <div className="col-md-6 col-6 col-sm-6 col-xs-6">
                          <div class="form-check">
                            <input
                              class="form-check-input"
                              type="radio"
                              name="Days"
                              value="Tweek"
                              checked={appDatas.Days === "Tweek"}
                              id="Tweek"
                              onChange={handleAppliedOns}
                            />
                            <label
                              class="form-check-label d-flex"
                              for="Tweek"
                              htmlFor="Tweek"
                              style={{ fontWeight: "bold" }}
                            >
                              This week
                            </label>
                          </div>
                        </div>
                        <div className="col-md-6 col-6 col-sm-6 col-xs-6">
                          <div class="form-check">
                            <input
                              class="form-check-input"
                              type="radio"
                              name="Days"
                              value="Lweek"
                              checked={appDatas.Days === "Lweek"}
                              id="Lweek"
                              onChange={handleAppliedOns}
                            />
                            <label
                              class="form-check-label d-flex"
                              for="Lweek"
                              htmlFor="Lweek"
                              style={{ fontWeight: "bold" }}
                            >
                              Last week
                            </label>
                          </div>
                        </div>
                        <div className="col-md-6 col-6 col-sm-6 col-xs-6">
                          <div class="form-check">
                            <input
                              class="form-check-input"
                              type="radio"
                              name="Days"
                              value="Tmonth"
                              checked={appDatas.Days === "Tmonth"}
                              id="Tmonth"
                              onChange={handleAppliedOns}
                            />
                            <label
                              class="form-check-label d-flex"
                              for="Tmonth"
                              htmlFor="Tmonth"
                              style={{ fontWeight: "bold" }}
                            >
                              This month
                            </label>
                          </div>
                        </div>
                        <div className="col-md-6 col-6 col-sm-6 col-xs-6">
                          <div class="form-check">
                            <input
                              class="form-check-input"
                              type="radio"
                              name="Days"
                              checked={appDatas.Days === "Lmonth"}
                              value="Lmonth"
                              id="Lmonth"
                              onChange={handleAppliedOns}
                            />
                            <label
                              class="form-check-label d-flex"
                              for="Lmonth"
                              htmlFor="Lmonth"
                              style={{ fontWeight: "bold" }}
                            >
                              Last month
                            </label>
                          </div>
                        </div>
                      </div> */}
                      <hr />
                      <div className="row mt-3">
                        <div className="col-md-4  col-4 col-sm-4">
                          <span
                            className="clearFilter ms-2 "
                            style={{ cursor: "pointer" }}
                            onClick={() => handleClear("appliedOns")}
                          >
                            Clear
                          </span>
                        </div>
                        <div className="col-md-8  col-8 col-sm-8">
                          <button
                            className="FilterButton"
                            onClick={() => handleApplyFilter("appliedOns")}
                          >
                            Apply Filter
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </th>

                <th id="th">
                  <span className="textHead_th">Action</span>
                </th>
              </tr>
            </thead>
            <tbody>
              {currentData?.length === 0 ? (
                <tr>
                  <td
                    colSpan="15"
                    style={{
                      textAlign: "center",
                      borderBottom: "1px solid #dee2e6",
                    }}
                  >
                    No records to display
                  </td>
                </tr>
              ) : (
                currentData?.map((course, index) => (
                  <tr
                    key={index}
                    className={
                      course.stock_status == 1 && course.delivery_status != 7
                        ? StyleInfo.redRow
                        : ""
                    }
                  >
                    <td id="td">{course.serialNumber}</td>

                    <td id={`${styles.td}tabTh`}>
                      <span
                        className={`${styles.ellipsis}`}
                        title={course.purchase_id}
                      >
                        {course.purchase_id}
                      </span>
                    </td>
                    <td id="td">{course.username} </td>
                    <td id="td">{course.email} </td>
                    <td id="td">
                      {course.phone_no == null ? "-" : course.phone_no}{" "}
                    </td>

                    <td id="td">{course.total_amount} </td>
                    <td id="td">
                      {" "}
                      {course.batch_name == null ? "-" : course.batch_name}{" "}
                    </td>

                    <td id="td">
                      {course.payment_mode === 1
                        ? "Online"
                        : course.payment_mode === 2
                        ? "QR Cash"
                        : course.payment_mode === 3
                        ? "Free"
                        : "Cash"}{" "}
                    </td>
                    <td id="td">
                      {course.delivery_mode == 1
                        ? "Courier Delivery"
                        : "Branch Pickup"}{" "}
                    </td>

                    <td id={`${styles.td}`}>
                      <span class="">{course.branch_location_name}</span>
                    </td>

                    {course.delivery_status_name && (
                      <td id={`${styles.td}`}>
                        <span class="">
                          {course.delivery_status_name || "_"}
                        </span>
                      </td>
                    )}
                    {/* delivery status */}
                    {/* {course.delivery_status == 0 && (
                      <td id={`${styles.td}`}>
                        <span class="filterChipText bg-blue ">
                          Pickup Pending
                        </span>
                      </td>
                    )}
                    {course.delivery_status == 1 && (
                      <td id={`${styles.td}`}>
                        <span class="filterChipText bg-orange">
                          Shipping in Progress
                        </span>
                      </td>
                    )}
                    {course.delivery_status == 2 && (
                      <td id={`${styles.td}`}>
                        <span class="filterChipText bg-green">Delivered</span>
                      </td>
                    )}
                    {course.delivery_status == 3 && (
                      <td id={`${styles.td}`}>
                        <span class="filterChipText bg-pink">Undelivered</span>
                      </td>
                    )} */}

                    <td id="td">
                      {course.enrolled_student == 1 ? "Yes" : "No"}{" "}
                    </td>
                    {/* <td id="td">{course.category_code} </td> */}
                    {/* <td id="td"> {course.subcategory_code}</td> */}
                    <td id="td">
                      {moment(course.date).utc().format("DD/MM/YYYY hh:mm:ss a")}
                    </td>
                    <td id="td">
                      <img
                        className="material-icons px-2"
                        src={ViewIcon}
                        onClick={(e) =>
                          handleView(
                            course.id
                            // course.category,
                            // course.type
                          )
                        }
                        alt="view icon"
                      />
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      <div className="row mt-2">
        <Pagination
          rowsPerPage={rowsPerPage}
          handlePageCount={handlePageCount}
          startPage={
            updateListData && updateListData?.length > 0
              ? currentPage * rowsPerPage + 1 - rowsPerPage
              : 0
          }
          endPage={
            updateListData && updateListData?.length > 0
              ? updateListData?.length < currentPage * rowsPerPage
                ? updateListData?.length
                : currentPage * rowsPerPage
              : 0
          }
          totalRecords={
            updateListData && updateListData?.length > 0
              ? updateListData?.length
              : 0
          }
          handlePrev={(e) => handlePrev(currentPage - 1)}
          currentPrevPage={currentPage === 1}
          prevButton={`${ListInfo.prev_buttonViewEvaluator} ${ListInfo.materialIconsRightAndLeft} me-2`}
          handleNext={() => handleNext(currentPage + 1)}
          currentNextPage={currentPage === totalPages || totalPages == 0}
        />
      </div>
    </div>
  );
}

export default ListPurchase;
